var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn-builder"},[_vm._l((_vm.btnList),function(item,index){return [_c(item.tag,{key:index,tag:"component",attrs:{"type":item.type,"icon":item.icon},on:{"click":item.click}},[_vm._v(" "+_vm._s(item.text)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }